<template>
    <div class="uploadBox">
        <!--selected images preview-->
        <div v-if="use_for_form" class="selected-images--preview">
            <h2 class="h2-responsive">

                {{use_for_form.selected_images.length}} {{pluralise('Image',use_for_form.selected_images.length)}}
                selected

            </h2>
            <div class="alert alert-info alert-dismissible fade show" role="alert">
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                First image added is the main image and used in banners. Others will be used to add more content to the
                page
                <p  class="font-italic font-weight-bold">
                    Images must have the correct aspect ratio to enforce consistency on the client layout. <br>
                    <a target="_blank" href="https://eventsupportteam.atlassian.net/wiki/spaces/DS/pages/567934977/Create+an+image+with+correct+aspect+ratio">See Here
                    to learn how to do it</a>
                </p>
            </div>
            <div class="row">
                <div :class="gallery.thumbnail_class"
                     v-for="(list_image,index) in use_for_form.selected_images"
                     @click="toggleSelected(list_image)"
                >

                    <input type="hidden"
                           v-model="list_image.table_id"
                           :name="use_for_form.selected_images_name"
                    >
                    <figure class="btn btn-primary gallery-image"
                            :class="{'gallery-image--main':(index<=0)}"
                    >
                        <picture :id="list_image.id"
                                 data-ref="thumbnail-preview"
                                 class="img-thumbnail gallery-image---thumbnail"
                                 :class="{ 'active': list_image.active }"
                        >
                            <img v-bind:srcset="list_image.src" :alt="list_image.title" class="img-fluid">
                        </picture>
                        <figcaption>
                            <h5 class="h5-responsive">{{list_image.title}}</h5>
                            <div class="gallery-image--tags">
                                    <span v-for="(tag,index) in list_image.tags">
                                        <span class="gallery-image--tag">{{tag}}</span>
                                        <span v-if="index+1 < list_image.tags.length">, </span>
                                    </span>
                            </div>
                        </figcaption>
                    </figure>
                </div>
            </div>
        </div>
        <ul class="nav nav-tabs nav-justified" id="images_finder">
            <!--Gallery preview-->
            <!--show gallery contains classes . nav-link active aria-expanded = true-->
            <li class="nav-item">
                <a @click.prevent="toggleTabs('gallery')"
                   :class="gallery.tabs.gallery.controller.classes"
                   href="#"
                   role="tab"
                ><i class="fa fa-image">
                </i> Gallery</a>
            </li>
            <!--Uploader-->

            <li class="nav-item">
                <a @click.prevent="toggleTabs('uploader')"
                   :class="gallery.tabs.uploader.controller.classes"
                   href="#"
                   role="tab"
                ><i class="fa fa-plus"></i> Add</a>
            </li>
        </ul>
        <!-- Tab panels -->
        <div class="tab-content">
            <!--Gallery preview-->
            <!--to show class = tab-pane fade in active show aria-expanded = true-->
            <!--not active class = tab-pane fade aria-expanded = false-->
            <div :class="gallery.tabs.gallery.content.classes" role="tabpanel">
                <div class="row">
                    <div class="col-12 pl-0 pr-0">
                        <div id="material_select--wrapper">
                            <material-select ref="image_tag_select" :id="gallery.select.id"
                                             @material_select_result="materialSelectItemSelected"
                            ></material-select>
                        </div>
                    </div>
                </div>
                <div class="row gallery-container">
                    <div class="gallery-image--gallery col-12 col-sm-6 col-md-4 mb-2 "
                         :class="{ 'active': list_image.active }"
                         v-for="list_image in list_images"
                         @click="toggleSelected(list_image)"
                    >
                        <figure class="btn btn-primary gallery-image">
                            <picture :id="list_image.id"
                                     class="img-thumbnail gallery-image---thumbnail"
                                     :class="{ 'active': list_image.active }"
                            >
                                <img v-bind:srcset="list_image.src" :alt="list_image.title" class="img-fluid">
                            </picture>
                            <figcaption>
                                <h5 class="h5-responsive">{{list_image.title}}</h5>
                                <div class="gallery-image--tags">
                                    <span v-for="(tag,index) in list_image.tags">
                                        <span class="gallery-image--tag">{{tag}}</span>
                                        <span v-if="index+1 < list_image.tags.length">, </span>
                                    </span>
                                </div>
                            </figcaption>
                        </figure>
                    </div>
                </div>
            </div>
            <!--Uploader-->
            <div id="addItem"
                 :class="gallery.tabs.uploader.content.classes"
                 role="tabpanel"
            >
                <form role="form"
                      enctype="multipart/form-data"
                      @submit.prevent="onUpload">
                    <div class="uploadBoxMain" v-if="!itemsAdded">
                        <div class="form-group">
                            <div class="dropArea" @ondragover="onImageInsert">
                                Drop multiple files here.
                                <input type="file" id="items" name="items[]" required multiple
                                       @change="onImageInsert"
                                >
                            </div>
                        </div>
                    </div>
                    <div class="uploadBoxMain" v-else>
                        <div class="row">
                            <div class="col-sm-12">
                                <!--begin looping through items-->
                                <div v-for="image_data in itemsNames">
                                    <!--                                    {{log('image_data',image_data)}}-->
                                    <div class="row mt-4">
                                        <div class="col-sm-8">
                                            <div class="row" data-ref="Image details">
                                                <div class="col-sm-12">
                                                    <div>
                                                        {{image_data.meta.name.value}} - {{image_data.size}}
                                                    </div>
                                                    <input type="hidden"
                                                           disabled
                                                           :id="image_data.meta.name.id"
                                                           :value="image_data.meta.name.value"
                                                    >
                                                </div>
                                                <div v-if="image_data.size_raw > fileSizeLimit "
                                                     class="col-sm-12">
                                                    <div class="text-danger alert alert-danger" role="alert">
                                                        <h3 class="px-0">Image file size too big. Max size is
                                                            {{fileSizeLimit}}M</h3>
                                                        <p>Reduce image file size before uploading</p>
                                                        <p>This image will not be uploaded</p>
                                                    </div>
                                                </div>
                                                <div v-else-if=" wrongRatio(image_data)"
                                                     class="col-sm-12">
                                                    <div class="text-danger alert alert-danger" role="alert">
                                                        <h3 class="px-0">Image Aspect Ratio not 16:9</h3>
                                                        <p class="">
                                                            <span class="d-block">Aspect ratio must be 16:9 e.g 1920x1080 pixels</span>
                                                        </p>
                                                        <p>Correct the image file aspect ratio first before attempting
                                                            to upload it see
                                                            <a target="_blank"
                                                               href="https://eventsupportteam.atlassian.net/wiki/spaces/DS/pages/567934977/Create+an+image+with+correct+aspect+ratio">Here
                                                                to learn how to do it</a></p>
                                                        <p class="font-weight-bold">This image will not be uploaded</p>
                                                    </div>
                                                </div>
                                                <!--file name watcher-->
                                                <template v-else>
                                                    <div class="col-sm-12">
                                                        <div class="md-form form-sm">
                                                            <i class="fa fa-font prefix"></i>
                                                            <input :id="image_data.meta.title.id"
                                                                   type="text"
                                                                   class="form-control"
                                                                   :disabled="image_data.size_raw > fileSizeLimit"
                                                                   :value="image_data.meta.title.value"
                                                                   @input="updateMetaModel($event.srcElement.value,image_data.id,'title','id')"
                                                            >
                                                            <label :for="image_data.meta.title.id"
                                                                   class="active">Title</label>
                                                        </div>
                                                    </div>
                                                    <!--tag input-->
                                                    <div class="col-sm-12">
                                                        <div class="md-form form-sm">
                                                            <i class="fa fa-tags prefix"></i>
                                                            <input type="text"
                                                                   autocomplete="off"
                                                                   v-model="tagModels[image_data.value]"
                                                                   :id="image_data.value + '_tags'"
                                                                   class="form-control"
                                                                   @input="readTagSuggestions(image_data.value)"
                                                                   v-on:keydown.space="createTag(image_data.value)"
                                                                   v-on:keydown.tab.prevent="createTag(image_data.value)"
                                                                   v-on:keydown.enter.prevent='createTag(image_data.value)'
                                                            >
                                                            <label :for="image_data.value + '_tags'">Choose
                                                                categories</label>
                                                        </div>
                                                        <div class="image_tag--suggest z-depth-1 animated d-none  pb-1"
                                                             :class="hideSuggestionClassEvent(image_data.value)"
                                                             :id="image_data.value + '_suggest'"
                                                        >

                                                            <i class="close fa-close fa"
                                                               v-on:click="closeSuggestion(image_data.value)"
                                                            ></i>
                                                            <div v-for="tag in tagSuggest[image_data.value]"
                                                                 class="chip"
                                                                 v-on:click="createTagNameRecord(image_data.value,tag)"
                                                            >
                                                                {{tag}}
                                                                <i class="fa fa-question"></i>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div class="chip"
                                                                 v-for="pill in tagPills[image_data.value]"
                                                            >
                                                                {{pill}}
                                                                <i class="close fa fa-times"
                                                                   v-on:click="deleteTag(pill,image_data.value)"
                                                                ></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>

                                            </div>
                                        </div>

                                        <!--image preview-->
                                        <div class="col-sm-4" data-ref="image_preview">

                                            <img :id="image_data.id + '_image'"
                                                 :key="image_data.id"
                                                 :ref="image_data.id"
                                                 :index="image_data.id"
                                                 :src="readImage(image_data.image,image_data.id + '_image')"
                                                 :alt="image_data.value"
                                                 class="show_image img-thumbnail"
                                            >
                                        </div>
                                    </div>
                                    <hr/>
                                </div>
                            </div>
                        </div>
                        <ul class="list-group">
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                Total files
                                <span class="badge badge-primary badge-pill">{{itemsAdded}}</span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                Total upload size
                                <span class="badge badge-primary badge-pill">{{itemsTotalSize}}</span>
                            </li>
                        </ul>
                        <!-- Loader -->
                        <div class="loader" v-if="isLoaderVisible">
                            <div class="loaderImg"></div>
                        </div>
                        <!-- End Loader -->
                    </div>
                    <div>
                        <button type="submit" class="btn btn-primary btn-black"
                                :disabled="itemsAdded < minItems || itemsAdded > maxItems"
                        ><i
                                class="fa fa-thumbs-o-up mr-1"
                        ></i>
                            Upload
                        </button>
                        <button type="button" class="btn btn-default" @click="removeItems"><i
                                class="fa fa-trash mr-1"
                        ></i>Cancel
                        </button>
                    </div>
                    <br>
                    <div class="successMsg" v-if="successMsg !== ''">{{successMsg}}</div>
                    <div class="errorMsg" v-if="errorMsg !== ''">An error has occurred:<br>{{errorMsg}}</div>
                    <div class="errorMsg" v-if="itemsAdded && itemsAdded < minItems">Minimum {{minItems}} files need to
                        be added to uploader. Please remove the files and try again.
                    </div>
                    <div class="errorMsg" v-if="itemsAdded && itemsAdded > maxItems">A maximum of {{maxItems}} files can
                        be uploaded each time. Please remove the files and try again.
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>

    require('es6-promise').polyfill();
    import axios from 'axios';
    import {HUB, CDN_URL, BUCKET_NAME, IMAGE_URL_BASE} from '../../../config';
    import {urlFormat} from '../../../urlFormat';
    import {inArray, createNestedObject} from '../../../helpers/arraysAndObjects';
    import {bytesToSize} from '../../../helpers/files';
    import {uniqueId} from '../../../helpers/classesAndIds';
    import {findActiveSelectedInputTagElement, watchSelectedOptionChange} from '../../../helpers/materialSelectVue';
    import MaterialSelect from '../../forms/select/MaterialSelect.vue';

    import {pluralise} from '../../../../../../app/Shared/Resources/Assets/js/helpers/strings'

    export default {
        created() {
            let self = this;
            self.$on('material_select_result', (data) => {
                self.selectedGalleryTagChange(data[0].optionValue);
            });
        },
        components: {
            'material-select': MaterialSelect
        },
        props: {
            cdn_type: String,
            minItems: {
                type: Number,
                default: 1
            },
            maxItems: {
                type: Number,
                default: 30
            },
            method: {
                type: String,
                default: 'post'
            },
            postMeta: {
                type: [String, Array, Object],
                default: ''
            },
//			successMessagePath: {
//				type: String,
//				required: true
//			},
//			errorMessagePath: {
//				type: String,
//				required: true
//			},
            /**
             * @property tags_url
             * @property list_url
             * @property upload_url
             * @namespace
             * */
            content: {}
        },
        mounted: function () {

            let self = this;

            self.postUrl = self.content.upload_url;
            self.listUrl = self.content.list_url;
            self.tagsUrl = self.content.tags_url;

            self.loadGallery();
            $('#images_finder a:first').tab('show');
            self.tagBackup = {
                models: self.tagModels,
                pills: self.tagPills
            };
            self.gallery.tabs.gallery.controller.classes = self.gallery.tabs.controller.active;
            self.gallery.tabs.gallery.content.classes = self.gallery.tabs.controller.active;

            self.gallery.tabs.uploader.controller.classes = self.gallery.tabs.controller.inactive;
            self.gallery.tabs.uploader.content.classes = self.gallery.tabs.content.inactive;
            self.showGallery();

            Vue.nextTick(function () {
                self.setupSelectedImages();
            })
        },

        /*
         * The component's data.
         */
        data: function () {
            return {
                fileSizeLimit: 1,
                showModal: false,
                isActive: false,
                gallery_id: 'gallery',
                gallery: {
                    select: {
                        id: uniqueId(),
                        name: 'gallery_select_name',
                        model: null,
                        watcher: null,
                        tag: false
                    },
                    tabs: {
                        content: {
                            active: 'tab-pane fade in active show',
                            inactive: 'tab-pane fade'
                        },
                        controller: {
                            active: 'nav-link active',
                            inactive: 'nav-link'
                        },
                        gallery: {
                            content: {
                                aria: 'true',
                                classes: 'tab-pane fade in active show',
                            },
                            controller: {
                                aria: 'false',
                                classes: 'nav-link active',
                            }
                        },
                        uploader: {
                            content: {
                                classes: 'tab-pane fade',
                                aria: 'true',
                            },
                            controller: {
                                classes: 'nav-link',
                                aria: 'false',
                            }
                        }
                    },
                    thumbnail_class: 'col-12 col-sm-6 col-md-4 mb-2 ',
                    modal: null
                },
                use_for_form: {
                    value: false,
                    selected_images: new Array(),
                    selected_backup_images: [],
                    selected_images_name: null
                },
                list_images: [],

                items: [],
                fileNameModels: [],
                itemsAdded: '',
                itemsNames: new Array(),
                itemsSizes: [],
                itemsTotalSize: '',
                formData: '',
                successMsg: '',
                errorMsg: '',
                isLoaderVisible: false,
                searchString: '',
                images: [],
                metaReferences: {
                    title: {},
                    name: {}
                },
                tags: {},
                tag_name: 'tags[]',
                searchTags: '',
                tagModels: [],
                tagModelValues: [],
                tagPills: new Array(),
                tagBackup: {},
                tagArray: new Array(),
                loadedFiles: [],
                itemsData: [],
                tagSuggest: new Array(),
                tags_chooser: {}
            }
        },
        methods: {
            log() {
                console.log.apply(console, arguments)
            },
            pluralise(text, count) {
                return pluralise(text, count);
            },

            materialSelectItemSelected(item) {
                this.ticket_selected_to_import = item[0].optionValue;
            },
            initMaterialSelect: function () {
                // compile tags for material select
                let tagsArray = [];
                for (let i = 0; i < this.tags.length; ++i) {

                    tagsArray[i] = {
                        id: this.tags[i],
                        lang: {
                            en_GB: {
                                title: this.tags[i]
                            }
                        }
                    }

                }

                this.tags_chooser = {
                    params: {
                        init_from_parent: true,
                        showSearch: true,
                        multiple: false,
//                        grouped: [],
                        grouped: [],
                        selected_input_name: 'tag_select',
                        label: 'Image Category',
                        placeholder: 'Select image category',
                        id: uniqueId('tags_chooser'),
                        link: {
                            add: false
                        },
                        top_option: {
                            title: ''
                        }
                    },
                    select_items: tagsArray
                };
                // console.log(' this.tags', tagsArray);
//                console.log('this.ticket_select_items',this.ticket_select_items);
//                 let tags_chooser = this.tags_chooser;
                this.$root.$emit('material_select', this.tags_chooser);

            },
            /**
             * After loading the dom with the gallery we next populate the selected images that were previously assigned
             * */
            setupSelectedImages() {
                let self = this;

                if (('use_for_form' in self.content)) {
                    self.use_for_form.value = self.content.use_for_form.value;
                    self.use_for_form.selected_images_name = self.content.use_for_form.selected_images_name;
//					console.log('self.content.use_for_form', self.content.use_for_form);

                    // console.log('self.content.use_for_form.selected_images', (self.content.use_for_form.selected_images !== null));

                    if (self.content.use_for_form.selected_images !== null) {
                        // console.log('begin loop', self.content.use_for_form.selected_images);

                        for (let imageProperty in self.content.use_for_form.selected_images) {
                            // console.log('image',imageProperty);
                            if (!self.content.use_for_form.selected_images.hasOwnProperty(imageProperty)) continue;
                            let image = self.content.use_for_form.selected_images[imageProperty];

                            // console.log('image', image);

                        }

                        for (let i = 0; i < self.content.use_for_form.selected_images.length; ++i) {
                            let image = self.content.use_for_form.selected_images[i];
                            // console.log('creating selected image', image);

                            self.createImageData(image, data => { //setup selected images
                                // console.log('list_images push', data);
                                self.list_images.push(data);
                                self.toggleSelected(data);
                            });
                        }
                    }
                }
            },

            /**
             * Highlights selected image for insertion into crud
             * any selected images must stay at the top
             * */
            toggleSelected(list_image) {
                let self = this;

                if (self.use_for_form.value === true) {
                    list_image.active = !list_image.active;

                    let imagesListedIds = [];

                    for (let i = 0; i < self.list_images.length; ++i) {
                        let listItem = self.list_images[i];

                        imagesListedIds.push(listItem.table_id);

                        if (list_image.table_id === listItem.table_id && listItem.table_id) {

                            // add to the selected list if it is active
                            if (list_image.active) {
                                self.use_for_form.selected_images.push(list_image);
                            } else {
                                // find the index in the selected images and splice it
                                for (let x = 0; x < self.use_for_form.selected_images.length; ++x) {

                                    if (list_image.table_id === self.use_for_form.selected_images[x].table_id) {
//										console.log('toggleSelected removing image', self.use_for_form.selected_images[x]);
                                        self.use_for_form.selected_images.splice(x, 1);
                                        self.use_for_form.selected_backup_images = self.use_for_form.selected_images;
                                        break;
                                    }
                                }
                            }
                        }
                    }

                    if (!imagesListedIds.includes(list_image.table_id)) {
                        let index = _.reject(self.use_for_form.selected_images, function (item) {
                            return item.table_id === list_image.table_id;
                        });
                        self.use_for_form.selected_images = index;
                        // console.log('not in array so remove it', list_image.table_id, 'index', index)
                    }
                }
            },

            /**
             *
             * */
            isImage(url, type) {
                if (type !== undefined) {
                    let pregMatch = `/\.(${type})$/`;

                    return (url.match(type) != null);
                }
                return (url.match(/\.(jpeg|jpg|gif|png|svg)$/) != null);

            },
            toggleTabs(id) {
                let self = this;

                if (id == 'gallery') {
                    self.gallery.tabs.gallery.controller.classes = self.gallery.tabs.controller.active;
                    self.gallery.tabs.gallery.content.classes = self.gallery.tabs.controller.active;

                    self.gallery.tabs.uploader.controller.classes = self.gallery.tabs.controller.inactive;
                    self.gallery.tabs.uploader.content.classes = self.gallery.tabs.content.inactive;
                    self.showGallery();
                } else {
                    self.showUploader();
                    self.gallery.tabs.gallery.controller.classes = self.gallery.tabs.controller.inactive;
                    self.gallery.tabs.gallery.content.classes = self.gallery.tabs.content.inactive;

                    self.gallery.tabs.uploader.controller.classes = self.gallery.tabs.controller.active;
                    self.gallery.tabs.uploader.content.classes = self.gallery.tabs.content.active;
                }
//				console.log('self.gallery.tabs', self.gallery.tabs);
            },
            /****************************************** GALLERY *******************************************************/
            /**
             * Tab controller for gallery tab
             * */
            showGallery() {
                let self = this;
//				$('#show--gallery').tab('show');

                this.use_for_form.selected_images = [];
                Vue.nextTick(function () {
                    self.use_for_form.selected_images = self.use_for_form.selected_backup_images;
                });
            },

            /**
             * Tab controller for upload form
             * */
            showUploader() {
                let self = this;
//				$('#show--uploader').tab('show');
                this.use_for_form.selected_images = [];
                Vue.nextTick(function () {
                    self.use_for_form.selected_images = self.use_for_form.selected_backup_images;
                });
            },
            /**
             * On change of the tags filter in the gallery, load the gallery filtered
             * */
            selectedGalleryTagChange(val) {
                val = val.trim();
                this.loadGallery({
                    tag: val
                });
            },

            /**
             * Axios request to get images and tags for gallery
             * */
            loadGallery(data) {
                let self = this,
                    _data = data || {};

                // display the gallery tab
                self.showGallery();
                self.gallery.select.tag = ('tag' in _data) ? _data.tag : false;
                //request the images
                axios({
                    method: 'get',
                    url: this.listUrl,
                    params: _data
                }).then((response) => {
                    self.list_images = [];

                    self.tags = response.data.tags.meta_references_data;

                    self.tagModels = self.tags;

                    Vue.nextTick(function () {
                        self.initMaterialSelect();
                    });
                    self.populateGallery(response.data.images);
                });
            },

            /**
             * Inserts images from request to gallery content
             * */
            populateGallery(images) {
                let data = images || [],
                    self = this;

                for (let i = 0; i < data.length; ++i) {
                    // console.log('data[i]',data[i]);
                    let imageData = self.createImageData(data[i]);

                    //is it in the selected list?
                    for (let x = 0; x < self.use_for_form.selected_images.length; ++x) {

                        if (imageData.id == this.use_for_form.selected_images[x].id) {
                            //image is active on the list
                            imageData.active = true;
                        }
                    }

                    Vue.nextTick(function () {
                        // console.log('imageData',imageData);
                        self.list_images.push(imageData);
                    });
                }
            },

            /**
             * User drags or inserts image/s for upload
             * */
            onImageInsert: function (e) {
                let self = this;

                self.clearTags();

                let files = e.target.files || e.dataTransfer.files,
                    fileSizes = 0;
                self.tagPills = [];
                self.successMsg = '';
                self.errorMsg = '';
                self.formData = new FormData();

                // console.error('typeof', typeof files);

                self.itemsAdded = files.length;

                for (let x in files) {
                    let testCasePosition = (x || null);

                    if (!isNaN(testCasePosition)) {

                        self.items = e.target.files[testCasePosition] || e.dataTransfer.files[testCasePosition];

                        self.$set(self.itemsNames, testCasePosition, {});

                        let newImage = files[testCasePosition];

                        let reader = new FileReader();
                        reader.readAsDataURL(newImage);
                        reader.onload = evt => {
                            let img = new Image();

                            img.onload = () => {
                                let test = (img.width / img.height) === (16 / 9);
                                console.log('test', test)
                                self.$set(self.itemsNames[testCasePosition], 'width', img.width);
                                self.$set(self.itemsNames[testCasePosition], 'height', img.height);
                                self.$set(self.itemsNames[testCasePosition], 'ratio', test);
                            };
                            img.src = evt.target.result;
                        };

                        reader.onerror = evt => {
                            console.error(evt);
                        };

                        let formatName = urlFormat(newImage.name, {
                            stripLastHyphen: true,
                            delimiter: ' ',
                            capitaliseAll: true,
                            matchString: [
                                {
                                    find: 'rc',
                                    replace: 'Rugby Club'
                                },
                                {
                                    find: 'fc',
                                    replace: 'Football Club'
                                }]
                        });
                        let mb = newImage.size / 1000000.0;
                        // build the item
                        let item = {
                            id: uniqueId(),
                            size: bytesToSize(newImage.size),
                            size_raw: mb.toFixed(2),
                            image: newImage,
                            value: formatName,
                            meta: {
                                name: {
                                    id: uniqueId(),
                                    value: newImage.name
                                },
                                title: {
                                    id: uniqueId(),
                                    value: formatName
                                },
                                tags: {
                                    value: []
                                }
                            }
                        };

                        Vue.set(self.itemsNames, testCasePosition, item);


                        self.itemsData[testCasePosition] = {
                            item: null,
                            size: bytesToSize(newImage.size)
                        };

                        self.itemsSizes[testCasePosition] = bytesToSize(newImage.size);

                        fileSizes += newImage.size;
                        self.formData.append('items[]', self.items);
                    }
                }

                self.itemsTotalSize = bytesToSize(fileSizes);
            },

            /**
             * Image is requested on load of the preview image model. Ite returns a data image and populates the src attribute
             * **/
            readImage(image, id) {
                // window.URL = window.webkitURL || window.URL; // Vendor prefixed in Chrome.

                setTimeout(function () {
                    let img = $('#' + id).get(0);

                    if (!img) {
                        return;
                    }
                    img.onload = function (e) {
                        window.URL.revokeObjectURL(img.src); // Clean up after yourself.
                    };
                    img.src = window.URL.createObjectURL(image);
                }, 2000)
            },

            /**
             * Removal tags from the image
             * */
            clearTags() {
                this.tagModels = this.tagBackup.models;
                this.tagPills = this.tagBackup.pills;
            },

            /**
             * User chose to cancel the uploading of images
             * */
            removeItems() {
                this.items = '';
                this.itemsAdded = '';
                this.itemsNames = [];
                this.itemsSizes = [];
                this.itemsTotalSize = '';
            },

            /**
             * Finally submits the images for the form
             * */
            onUpload() {
                this.isLoaderVisible = true;
                let self = this;

                this.createTagsForForm();
                this.createDetailsForForm();

                if ((typeof this.postMeta === 'string' && this.postMeta !== '') ||
                    (typeof this.postMeta === 'object' && Object.keys(this.postMeta).length > 0)) {
                    this.formData.append('postMeta', this.postMeta);
                }

                let data = {
                    method: this.method,
                    url: this.postUrl,
                    data: this.formData,
                    image: this.formData
                };
                if (this.method === 'put' || this.method === 'post') {
                    axios(data)
                        .then((response) => {
                            self.isLoaderVisible = false;
                            // Show success message
//							this.successMsg = response + "." + this.successMessagePath;
                            self.successMsg = "Upload successful";
                            self.removeItems();
                            self.loadTags();

                            let data = response.data.uploaded;
                            for (let i = 0; i < data.length; ++i) {
                                let list_image = data[i].uploaded,
                                    imageData = self.createImageData(list_image);

                                imageData.active = false;

                                Vue.nextTick(function () {
                                    self.list_images.push(imageData);
                                    self.toggleSelected(imageData);
                                });
                            }

                        })
                        .catch((error) => {
                            this.isLoaderVisible = false;
                            this.errorMsg = error + ". failed";
                            this.removeItems();
                        });
                } else {
                    this.errorMsg = "This HTTP method is not allowed. Please use either 'put' or 'post' methods.";
                    this.removeItems();
                }
            },

            /**
             * Creates the data for inclusion into the vue
             * @property data.image_data;
             * @param {Object} data
             * @param {function} initImage
             * */
            createImageData(data, initImage) {
                // console.log('createImageData', typeof initImage, initImage);
                //check list images first to see if it is already there
                let imageTemp = {
                    id: 'gallery-image--' + data.id,
                    table_id: data.id,
                    // src: CDN_URL +  BUCKET_NAME + data.url,
                    src: `${CDN_URL}${BUCKET_NAME}/${(typeof IMAGE_URL_BASE[this.cdn_type] !== 'undefined' && IMAGE_URL_BASE[this.cdn_type] !== null) ? IMAGE_URL_BASE[this.cdn_type] : ''}${data.url}`,
                    title: data.image_data.lang.en_GB.title,
                    tags: data.image_data.tags,
                    active: (typeof initImage !== undefined && typeof initImage === 'function') ? false : null //sets to false so that the image can be toggled to view
                };
                if (typeof initImage === 'function') {
//					console.log('executing callback');
                    initImage(imageTemp);
                } else {
//					console.log(imageTemp, '(typeof initImage !== undefined) ? false : null', (typeof initImage !== undefined) ? 'was init' : 'nope');
                    return imageTemp;
                }

            },

            /**
             * Creates details[] array to parse to the uploader
             * */
            createDetailsForForm() {
                for (let i in this.itemsNames) {
                    if (this.itemsNames[i].ratio === true) {
                        this.formData.append('details[]', JSON.stringify(this.itemsNames[i]));
                    }
                }

                this.formData.append('cdn_type', this.cdn_type);
            },

            /**
             * When the user enters a new title etc
             * */
            updateMetaModel(eventValue, id, tag, pointer) {
                let position = null,
                    inputId = id,
                    value = eventValue;

                //find the id in the loop
                for (let i in this.itemsNames) {

                    if (id == this.itemsNames[i][pointer]) {
                        position = i;
                        break;
                    }

                }
                if (position !== null) {
                    Vue.set(this.itemsNames[position].meta[tag], 'value', value);
                }
            },

            /**
             * Work around for forming image tags for the form submission
             * */
            createTagsForForm() {

                let self = this, compiled = new Array();
                for (let i in this.tagPills) {
                    let prop = (i || null);
                    let tags = new Array();
                    for (let x in this.tagPills[prop]) {
                        tags.push({
                            name: this.tagPills[prop][x]
                        });
                    }
                    self.updateMetaModel(tags, prop, 'tags', 'value');
                }
            },

            /***************************************** TAGS ***********************************************************/
            /**
             * Reads the tag input field and searches for potenial matches within the core loaded tags library
             * @param {String} id
             * */
            readTagSuggestions(id) {
                let self = this,
                    tagNameRaw = this.tagModels[id],
                    tagName = urlFormat(tagNameRaw, {
                        stripLastHyphen: true
                    }),
                    searchTagsArray = this.tags;

                if (tagName.length <= 0 || tagName.length < 2) {
                    this.closeSuggestion(id);
                    return;
                }
                searchTagsArray = searchTagsArray.filter(function (item) {
                    if (item.indexOf(tagName) !== -1) {
                        return item;
                    }
                });

                if (searchTagsArray.length > 0 && searchTagsArray.length !== this.tags.length) {
                    self.tagSuggest[id] = searchTagsArray;
                    self.openSuggestion(id);
                }
                // Return an array with the filtered data.
                return searchTagsArray;
            },

            /**
             * update the suggestion box class based on this.tagSuggest content
             * @param {string}  id
             * */
            hideSuggestionClassEvent(id) {
                if (id in this.tagSuggest) {
                    if (this.tagSuggest[id].length > 0) {
                        return 'd-block fadeIn';
                    } else {
                        return 'fadeOut'
                    }
                }
                return 'fadeOut';
            },

            /**
             * Close the suggestion box
             * @param {string}  id
             * */
            closeSuggestion(id) {
                this.tagSuggest[id] = new Array();
                $(`#${id}_suggest`).addClass('fadeOut').removeClass('fadeIn')
            },

            /**
             * Open the suggestion box
             * @param {string}  id
             * */
            openSuggestion(id) {
                $(`#${id}_suggest`).addClass('fadeIn').removeClass('fadeOut')
            },

            /**
             * Creates an array of tags to add to the pills
             * upon entering a space. the insert happens
             * @param {string}  id
             */
            createTag(id) {
                let tagNameRaw = this.tagModels[id];
                if (!tagNameRaw) {
                    return
                }
                this.createTagNameRecord(id, urlFormat(tagNameRaw, {stripLastHyphen: true}));
                return false;
            },

            /**
             * Creates and populates the tag pill for the selected image
             * @param {string}  id
             * @param {string}  tagName
             * */
            createTagNameRecord(id, tagName) {
                let self = this;

                if (tagName !== '') {

                    if (tagName.length > 0) {
                        if (!this.tagPills.hasOwnProperty(id)) {
                            this.tagPills[id] = [];
                        }
                        if (this.tagPills[id].indexOf(tagName) < 0) {
                            this.tagPills[id].push(tagName);
                        }
                        this.tagModels[id] = '';
                        self.closeSuggestion(id);
                        if (this.tags.indexOf(tagName) === -1) {
                            this.tags.push(tagName);
                        }
                    }
                }
            },

            /**
             * Delete the selected tag from the list
             * */
            deleteTag: function (tag, id) {
                let array = this.tagPills[id],
                    i = array.indexOf(tag);

                if (i != -1) {
                    array.splice(i, 1);
                }
                this.tagPills[id] = array;
                this.tagModels[id] = '';
            },

            /**
             * Request all tags
             */
            loadTags() {
                let self = this;
                axios({
                    method: 'get',
                    url: this.tagsUrl
                })
                    .then((response) => {
                        self.tags = response.data.meta_references_data;
                        self.tagModels = self.tags;
                        // console.log('self.tags', self.tags);
                    })
                    .catch((error) => {

                    });
            },
            debug(id, val) {
                console.log('debug', id, 'val', val);
            },
            wrongRatio(image_data) {
                if (!image_data.hasOwnProperty('ratio')) {
                    return false;
                }
                // console.log('(image_data.ratio === false)',(image_data.ratio === false),'image_data.ratio',image_data.ratio)
                return image_data.ratio === true ? false : true;
            }

        },
        // watch: {
        //     itemsNames: function() {
        //         console.log(this.itemsNames[0].ratio)
        //     }
        // }
    }
</script>

<style>
    .mdb-select-vue {
        display: block !important;
        background-color: transparent;
        border-top: 0 solid transparent;
        border-left: 0 solid transparent;
        border-right: 0 solid transparent;
        border-bottom: 1px solid #ccc;
        font-size: 16px;
        height: 34px;
        width: 268px;
        border-radius: 0;
        -webkit-appearance: none;
        margin-bottom: 1em;
        padding-left: 1rem;
    }

    .mdb-select-vue:focus {
        outline: none;
    }

    .image_tag--suggest {
        position: absolute;
        left: 4rem;
        top: 4rem;
        padding: 1rem;
        background-color: white;
        border: 1px solid #cacaca;
        width: 100%;
        text-align: center;
        cursor: pointer;
        background-clip: border-box;
        z-index: 99999;
    }

    .gallery-container {
        max-height: 50vh;
        box-shadow: inset 0 0 20px #e0e0e0;
        overflow-x: hidden;
        background: #fdfdfd;
    }

    .uploadBox {
        position: relative;
    }

    .uploadBox h3 {
        padding-top: 1em;
    }

    .uploadBox .uploadBoxMain {
        position: relative;
    }

    /* Drag and drop */
    .uploadBox .dropArea {
        position: relative;
        width: 100%;
        height: 200px;
        border: 1px dashed #00ADCE;
        text-align: center;
        font-size: 2em;
        padding-top: 80px;
    }

    .uploadBox .dropArea input {
        position: absolute;
        cursor: pointer;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
    }

    /* End drag and drop */

    /* Loader */
    .uploadBox .loader {
        position: absolute;
        top: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #fff;
        opacity: 0.9;
    }

    .uploadBox .loaderImg {
        border: 9px solid #eee;
        border-top: 9px solid #00ADCE;
        border-radius: 50%;
        width: 70px;
        height: 70px;
        animation: spin 1s linear infinite;
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    /* End Loader */

    .uploadBox .errorMsg {
        font-size: 2em;
        color: #a94442;
    }

    .uploadBox .successMsg {
        font-size: 2em;
        color: #3c763d;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/image/ImageUploader.vue?7831c335